import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react'
import ContentHeader from '../../../Layout/ContentHeader'
import LayoutTable from '../../../Global/LayoutTable'
import { useMutation, useQuery } from '@apollo/client'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import {
  DELETE_SUB_JURISDICTIONS,
  GET_ALL_JURISDICTION_SUBS,
  GET_JURISDICTION_GROUPS_CATEGORIES_SUB_BY_SUB_JURISDICTION_ID,
} from '../../../../graphql/Catalog/Jurisdictions/jurisdictionSub'
import ModalContent from '../../../Global/ModalContent'
import ZonesModal from './ZonesModal'

const idModal = 'modalJurisdiction'

const Zones = () => {
  const refModal = useRef()

  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
  })
  const [total, setTotal] = useState(0)
  const { loading, error, data } = useQuery(GET_ALL_JURISDICTION_SUBS, {
    variables: {
      searchQuery: pagePagination.searchQuery,
      limit: pagePagination.limit,
      offset: pagePagination.offset,
    },
  })
  const [JurisdictionGroupsSelected] = useMutation(
    GET_JURISDICTION_GROUPS_CATEGORIES_SUB_BY_SUB_JURISDICTION_ID
  )

  const [dataToTable, setDataToTable] = useState([])
  const [modalContent, setModalContent] = useState({
    title: '',
    content: null,
  })

  useEffect(() => {
    if (!loading) {
      if (error)
        toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      const { rows, count } = data.getAllJurisdictionsSub
      const list = rows.map((item) => ({
        id: item.id,
        Nombre: item.name,
        // 'Asignar Subcategorias': (
        //   <button
        //     type="button"
        //     className="btn btn-sm btn-migrates"
        //     data-toggle="modal"
        //     data-target={`#${idModal}`}
        //     onClick={() => showModal(item)}
        //   >
        //     Asignar
        //   </button>
        // ),
      }))
      setDataToTable(list)
      setTotal(count)
    }
  }, [loading, error, data])

  const showModal = useCallback(async (item) => {
    try {
      const res = await JurisdictionGroupsSelected({
        variables: {
          id: parseInt(item.id),
        },
      })
      if (!res?.data?.getjurisdictionGroupsCategoriesSubBySubJurisdictionId)
        return toastSweetAlert({
          mode: 'error',
          message: 'No se encontraron datos',
        })

      const initialIds =
        res?.data?.getjurisdictionGroupsCategoriesSubBySubJurisdictionId.map(
          (item) => item.sub_category_id
        )
      setModalContent({
        title: `SubJurisdicción ${item.name}`,
        content: (
          <ZonesModal
            id={parseInt(item.id)}
            refModal={refModal}
            initialIds={initialIds}
          />
        ),
      })
    } catch (error) {
      toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [JurisdictionGroupsSelected, refModal])

  const handleCloseModal = useCallback(() => {
    setModalContent({ title: null, content: null })
  }, [])

  return (
    <>
      <ContentHeader
        title="Zonas"
        breadcrumb="zonas"
        windowTitle="Zonas"
      />
      <LayoutTable
        title="Lista de zonas"
        data={dataToTable}
        requery={GET_ALL_JURISDICTION_SUBS}
        gql={DELETE_SUB_JURISDICTIONS}
        exportImportButton={false}
        totalCount={total}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        loadingData={loading}
        FilterBarPlaceholder="Buscar por nombre"
        hideDetails
      />

      <span
        id={`spanModal${idModal}`}
        ref={refModal}
        className="btn invisible"
        data-toggle="modal"
        data-target={'#' + idModal}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
      />

      <ModalContent
        idModal={idModal}
        title={modalContent.title}
        size="extra"
        onClose={handleCloseModal}
        content={modalContent.content}
      />
    </>
  )
}

export default Zones
